export default __webpack_public_path__ + "static/media/airdrop.839d6bd8.png";